import { useIsMobile } from '@sravni/react-utils';
import { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';

import { sendPreApprovalsSearchApplicationThunk } from './sendPreApprovalsSearchApplicationThunk';

export const useSendPreApprovalsSearchApplication = () => {
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();

  return useCallback(async () => {
    const result = await dispatch(
      sendPreApprovalsSearchApplicationThunk({
        sourceUrl: window.location.href,
        deviceType: isMobile ? 'mobile' : 'desktop',
      }),
    );
    return !!result.payload;
  }, [dispatch, isMobile]);
};
